export const links = [
    { url: "/", label: "Home" },
    { url: "/about", label: "About us" },
    { url: "/services", label: "Services" },
    { url: "/contact", label: "Helpline" },
    { url: "/team", label: "Our Team" },
    { url: "/drivers", label: "Driver" }
]

export const products = [
    { url: "https://play.google.com/store/apps/details?id=com.uracabtest&pcampaignid=web_share", label: "Ride" },
    { url: "/drivers", label: "Drive" },
]

export const travels = [
    { url: "", label: "Intracity" },
    { url: "", label: "Intercity" },
    { url: "", label: "Interstate" },
]

export const supports = [
    { url: "/support/account", label: "Accounts Related" },
    { url: "/support/booking", label: "Bookings Related" },
    // { url: "", label: "Fee & Charges Related" },
]


export const features = [
    // { image: '/affordable.png', title: "Affordability", descriptions: 'Fare estimates help passengers plan their transportation budget more effectively.' },
    { image: '/ease.png', title: "Accessiblity", descriptions: 'Uracab offers a one click solution, bringing taxi to your doorstep.' },

    { image: '/shield.png', title: "Safety", descriptions: 'Access to safety features, including real-time tracking, driver ratings, and emergency support to enhance passenger security.' },
    { image: '/handshake.png', title: "Reliability", descriptions: 'Structured and reasonable fares. No surprises, no hidden fees. Consistent pricing you can count on.' },

    // { image: '/income.png', title: "Income Opportunities", descriptions: 'Drivers can earn income through flexible work schedules, providing an additional source of employment.' },
    { image: '/congestion.png', title: "Reduced Congestion", descriptions: 'Easy access to taxis help reduce traffic congestion and parking problems.' }
]

export const teamList = [
    { id: 1, img: "https://uracab.com/Keduolie.jpg", name: "Keduolie Mere", organization: "URACAB PRIVATE LIMITED", position: "Chief Executive Officer", description: "Keduolie Mere is the CEO of URACAB PRIVATE LIMITED, responsible for setting the strategic direction and overseeing the overall operations of the organization. Focused on driving growth and innovation, Mere ensures that UraCab maintains its competitive edge and meets its long-term goals. As the face of the company, Mere collaborates with key stakeholders and leads the leadership team to execute the company’s vision." },
    { id: 5, img: "https://uracab.com/Kaushal.jpg", name: "Kaushal Bey", organization: "URACAB PRIVATE LIMITED", position: "Chief Technical Officer", description: "Kaushal Bey is the CTO at URACAB PRIVATE LIMITED, leading the technological direction and overseeing all aspects of technology strategy and development. Kaushal ensures that the company’s IT infrastructure, product development, and technology teams are aligned with the company’s goals. Kaushal plays a crucial role in driving innovation and ensuring the company remains technologically competitive." },
    { id: 9, img: "https://uracab.com/Kekhriesetuo.png", name: "Kekhriesetuo Ziephru", organization: "URACAB PRIVATE LIMITED", position: "Advisor", description: "Kekhriesetuo Ziephru is an advisor at URACAB PRIVATE LIMITED, offering strategic insights and expert guidance to support the company’s growth and operations. Kekhriesetuo provides valuable input on key business decisions and helps the leadership team navigate challenges and capitalize on opportunities. Kekhriesetuo contributes to the company’s success by offering well-informed advice across various areas, including strategy and operations." },
    { id: 4, img: "https://uracab.com/Bituo.jpg", name: "Keneilezo Kevin Rutsa", organization: "URACAB PRIVATE LIMITED", position: "General Manager", description: "As General Manager at URACAB PRIVATE LIMITED, Keneilezo Kevin Rutsa is responsible for overseeing day-to-day business operations, ensuring smooth processes, and managing teams across various departments. Keneilezo works to ensure that company policies are implemented effectively and that operational targets are consistently met. Keneilezo is focused on driving operational success and maintaining efficient workflows." },
    // { id: 4, img: "https://uracab.com/Ride.jpg", name: "Ride Mero", organization: "URACAB PRIVATE LIMITED", position: "Asst. General Manager.", description: "" },
    { id: 4, img: "https://uracab.com/seyei.jpg", name: "Seyievilie Metha", organization: "URACAB PRIVATE LIMITED", position: "Technical Relations Officer.", description: "" },
    { id: 4, img: "https://uracab.com/martin.png", name: "Thepfuzhalie Mere", organization: "URACAB PRIVATE LIMITED", position: "Fleet Manager.", description: "" },
    { id: 6, img: "https://uracab.com/atouzo.jpg", name: "Atouzo Metha", organization: "URACAB PRIVATE LIMITED", position: "Asst. Fleet Manager", description: "" },
    { id: 9, img: "https://uracab.com/vikepelie.jpg", name: "Vikepelie Kruse", organization: "URACAB PRIVATE LIMITED", position: "Developer", description: "" },
    { id: 9, img: "https://uracab.com/theja.jpg", name: "Thejasetuo Kesi-ü", organization: "URACAB PRIVATE LIMITED", position: "Developer", description: "" },
    { id: 9, img: "https://uracab.com/montok.jpg", name: "Montok C Konyak", organization: "URACAB PRIVATE LIMITED", position: "Developer", description: "" },
    { id: 9, img: "https://uracab.com/lima.jpg", name: "Limakumten Phom", organization: "URACAB PRIVATE LIMITED", position: "Developer", description: "" },
    { id: 9, img: "https://uracab.com/chingmei.jpg", name: "M Chingmei Phom", organization: "URACAB PRIVATE LIMITED", position: "Developer", description: "" },


]

export const privacyPolicies = {
    introductions: `UraCab Pvt Ltd ("we," "us," or "our") is committed to protecting your
          privacy. This Privacy Policy explains how we collect, use, disclose,
          and protect your personal information when you use our online cab
          service and related services (collectively, the "Services"). By
          accessing or using our Services, you consent to the practices
          described in this Privacy Policy. Please take a moment to carefully
          read this Privacy Policy and contact us if you have any questions or
          concerns about your personal information.`,
    sections: [
        {
            title: "1. Information We Collect",
            content: [
                "<h4>1.1 Information You Provide to Us</h4><p>When you use our Services, we may collect information you provide directly to us, including but not limited to:</p><ul><li>Contact Information: Your name, email address, phone number, and postal address.</li><li>Account Information: If you create an account with us, we collect your username and password.</li><li>Payment Information: Your credit card or payment card information.</li><li>Trip Information: Information about your trips, including pick-up and drop-off locations, distance traveled, and payment history.</li><li>Communications: Records and copies of your communications with us.</li></ul><h4>1.2. Information We Collect Automatically</h4><p>When you use our Services, we may also automatically collect certain information about your device and usage patterns, including:</p><ul><li>Device Information: Your device's type, operating system, unique device identifier, and mobile network information.</li><li>Location Information: Your device's GPS location data, IP address, and other information about your location.</li><li>Usage Information: Information about how you use and interact with our Services, including the date and time of your visits, pages viewed, and the actions you take.</li><li>We may access your camera and storage solely for the purpose of uploading and updating your profile picture, and all data will be handled in accordance with our privacy policy to ensure your information is secure.</li></ul><h4>1.3. Information We Collect from Third Parties</h4><p>We may receive information about you from third-party sources, such as social media platforms, advertising partners, and analytics providers.</p>",
            ],
        },
        {
            title: "2. How We Use Your Information",
            content: [
                "We may share your personal information with third parties in the following circumstances:<ul><li>Providing and maintaining the Services.</li><li>Processing and completing your bookings and payments.</li><li>Communicating with you about your bookings and providing customer support.</li><li>Improving our Services and developing new features.</li><li>Sending you promotional and marketing communications, if you have opted in to receive them.</li><li>Analyzing usage patterns and trends to enhance our Services and website.</li><li>Complying with legal obligations and protecting our rights and the rights of others.</li></ul>",
            ],
        },
        {
            title: "3. Sharing Your Information",
            content: [
                "We may share your personal information with third parties in the following circumstances:<ul><li>With our service providers, business partners, and affiliates who assist us in delivering and improving our Services.</li><li>With law enforcement, government agencies, or authorized third parties when required by law or to protect our legal rights or the safety of others.</li><li>In connection with the sale, merger, or transfer of all or part of our company.</li><li>With your consent or at your direction.</li></ul>",
            ],
        },
        {
            title: "4. Your Choices",
            content: [
                "You have choices regarding the collection and use of your personal information:<ul><li>You can review and update your account information at any time by logging into your account settings.</li><li>You can opt out of receiving promotional emails by following the unsubscribe instructions in the emails we send you.</li><li>You can disable location services on your device, but this may limit your ability to use certain features of our Services.</li></ul>",
            ],
        },
        {
            title: "5. Security",
            content: [
                "We take reasonable measures to protect your personal information from unauthorized access, disclosure, alteration, and destruction. However, please be aware that no method of internet transmission or electronic storage is completely secure, and we cannot guarantee the security of your data.",
            ],
        },

        {
            title: "6. Changes to this Privacy Policy",
            content: [
                "We may update this Privacy Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. We will notify you of any material changes by posting the updated Privacy Policy on our website and indicating the date of the latest revision.",
            ],
        },

    ]
}

export const termsOfUse = [
    {
        title: "1. Acceptance of Terms",
        content: [
            "By accessing or using the services provided by UraCab Pvt Ltd ('UraCab'), you agree to comply with and be bound by these Terms of Use. If you do not agree to these terms, please do not use our services.",
        ],
    },
    {
        title: "2. Use of Our Services",
        content: [
            "You must be at least 18 years old to use UraCab's services.",
            "You agree to use our services for lawful purposes and in accordance with all applicable laws and regulations.",
            "You will not:",
            "<ul><li>Violate any local, state, national, or international laws.</li><li>Interfere with the operation of our services or the rights of other users.</li><li>Provide false information when creating an account or using our services.</li></ul>",
        ],
    },
    {
        title: "3. User Accounts",
        content: [
            "To use certain features of our services, you may need to create a user account. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account. You agree to notify us immediately of any unauthorized access or use of your account.",
        ],
    },
    {
        title: "4. Payments",
        content: [
            "You agree to pay all fees and charges associated with your use of UraCab's services. All payments are non-refundable. UraCab reserves the right to change its pricing and to introduce new charges at any time.",
        ],
    },
    {
        title: "5. Refund",
        content: [
            "Once the refund request is approved, The Refunded Amount will be processed and credited within 10 days to the original mode of payment.",
        ],
    },
    {
        title: "6. User Content",
        content: [
            "By using our services, you may have the opportunity to submit content, such as ratings, reviews, and comments. You grant UraCab a non-exclusive, worldwide, royalty-free license to use, modify, reproduce, and display such content in connection with our services.",
        ],
    },
    {
        "title": "7.  Safety Policies",
        "content": [
            "<h4>6.1 Zero Tolerance Policy</h4><p>At UraCab, we're dedicated to providing our customers with the best possible safety standards. We have a stringent zero tolerance policy regarding our drivers' usage of drugs and alcohol in order to fulfill this promise. Our goal is to give every customer who utilizes our service a safe, dependable, and enjoyable transportation experience, and this policy is essential to achieving that goal.</p><p>Because of our zero tolerance policy, it is strictly forbidden for drivers to use or be under the influence of any intoxicating substances, including alcohol or narcotics, while operating a motor vehicle. This covers both over-the-counter and prescription medications that could make it unsafe for them to drive. Our drivers' total sobriety and attentiveness are crucial to the safety of our passengers, and we take this duty very seriously.</p><p>To enforce this policy, we have put in place strict procedures, such as frequent training for drivers on the value of sobriety and the possible repercussions of breaking the law. Drivers receive education about the detrimental effects of alcohol and drugs on their ability to drive and the significant hazards they pose to the safety of their passengers. We also regularly monitor and perform random testing to make sure that our zero tolerance criteria are being followed.</p><p>If a motorist is discovered to be breaking this rule, they will be dealt with right away. As part of this, the driver's access to the UraCab platform will be suspended while a comprehensive inquiry is carried out. In order to choose the best course of action, we will compile all pertinent data and evidence during this investigation. Discipline may take the shape of required retraining sessions or permanent deactivation from our site, depending on how serious the infraction was.</p><p>Additionally, we advise patrons to exercise caution and report any suspicions of driver impairment. We take passenger reports very seriously and consider them to be an essential part of our safety enforcement approach.</p><h4>6.2 Driver Compliance Notice</h4><p>UraCab has a zero tolerance policy that all drivers must rigorously abide by at all times. This policy must be followed; it is not negotiable. Any infraction, including using drugs or alcohol while operating a vehicle, will result in an instant suspension from the platform and a thorough inquiry. This policy is in place to safeguard both the integrity of our service and the safety of our guests.</p>"
        ]
    },
    {
        title: "8. Disclaimer of Warranties",
        content: [
            'UraCab\'s services are provided "as is" and "as available" without any warranties of any kind, either express or implied, including, but not limited to, the implied warranties of merchantability, fitness for a particular purpose, or non-infringement.',
        ],
    },
    {
        title: "9. Limitation of Liability",
        content: [
            "In no event shall UraCab be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses, resulting from your use or inability to use our services.",
        ],
    },
    {
        title: "10. Governing Law",
        content: [
            "These Terms of Use are governed by and construed in accordance with the laws of India. UraCab Pvt Ltd is a company registered under the laws of India, without regard to its conflict of law principles.",
        ],
    },
    {
        title: "11. Changes to Terms",
        content: [
            "UraCab reserves the right to modify or replace these Terms of Use at any time. It is your responsibility to review these terms periodically for changes. Your continued use of our services after any changes to these terms constitutes acceptance of those changes.",
        ],
    },
];


export const getKeyLabel = (key: string) => {
    switch (key) {
        case "pan_no":
            return "PAN number";
        case "driver_ID":
            return "Driver Id";
        case "name":
            return "Name";
        case "fname":
            return "Father's name";
        case "dob":
            return "Date of birth";
        case "pdf":
            return "Document file";
        case "verification":
            return "Verification status";
        case "aadhaar_no":
            return "Aadhaar number";
        case "gender":
            return "Gender";
        case "address":
            return "Address";
        case "aadhaar_no":
            return "Aadhaar number";
        case "account_no":
            return "Account number";
        case "bank_name":
            return "Bank name";
        case "ifsc":
            return "IFSC code";
        case "holder_name":
            return "Account holder name";
        case "branch":
            return "Branch name";
        case "id":
            return "Id";
        case "place":
            return "Village/Town";
        case "sardar":
            return "Sardar";
        case "district":
            return "District";
        case "license_no":
            return "License number";
        case "blood group":
            return "Blood group";
        case "vehicle_class":
            return "Vehicle Class";
        case "date_of_issue":
            return "Date of issue";
        case "valid_upto":
            return "Valid upto";
        case "parent_name":
            return "Parent name";
        case "reg_no":
            return "Registration number";
        case "reg_date":
            return "Registration Date";
        case "owner":
            return "Owner";
        case "chassis_no":
            return "Chassis number";
        case "engine_no":
            return "Engine number";
        case "manufacturer":
            return "Manufacturer";
        case "model_no":
            return "Model number";
        case "color":
            return "Color";
        case "mfg_date":
            return "Manufacturing date";
        case "district":
            return "District";
        case "inspect_on":
            return "Inspect on";
        case "expire_on":
            return "Expire on";
        case "inspection_due":
            return "Inspection due";
        case "fee_receipt_no":
            return "Fee receipt number";
        case "application_no":
            return "Application number";
        case "receipt_date":
            return "Receipt date";
        case "seating_capacity":
            return "Seating capacity";
        case "body_type":
            return "Body type";
        case "vehicle_category":
            return "Vehicle Category";
        case "mfg_year":
            return "Manufacturing year";
        case "printed_on":
            return "Printed on";
        case "permit_no":
            return "Permit number";
        case "name1":
            return "First name";
        case "name2":
            return "Second name";
        case "address1":
            return "First address";
        case "address2":
            return "Second address";
        case "contact1":
            return "First contact";
        case "contact2":
            return "Second contact";
        default:
            return key;
    }
}

export const accountSupport = [
    {
        title: "Account Registration",
        id: "registration",
        sections: [
            {
                title: "Step 1: Launch the App or Website",
                sections: ["Open our app or visit our website to begin the registration process."]
            },
            {
                title: "Step 2: Fill Out the Registration Form",
                subsections: {
                    title: "If you're a new user, you will be required to fill out a registration form with the following details:",
                    sections: ["Name (Required)", "Email (Optional)", "Mobile Number (Required)"]
                }
            },
            {
                title: "Step 3: Verify Your Mobile Number",
                sections: ["After entering your details, you'll receive a One-Time Password (OTP) on your mobile number.", "Enter the OTP in the field provided to complete the authentication process. This ensures that the mobile number belongs to you and is used for account verification."]
            },

            {
                title: "Step 4: Complete Your Registration",
                sections: ["Once the OTP is verified, your account will be successfully created. You can now book taxis, view your ride history, and manage your profile."]
            },
        ]
    },
    {
        title: "Account Login for Existing Users",
        id: "login",
        sections: [
            {
                title: "Step 1: Open the App or Website",
                sections: ["Launch the app or go to our website."]
            },
            {
                title: "Step 2: Enter Your Mobile Number",
                sections: ["If you're already a registered user, simply enter your mobile number in the login section."]
            },
            {
                title: "Step 3: OTP Authentication",
                sections: ["You will receive an OTP on your mobile number.", "Enter the OTP to authenticate and access your account. Once verified, you'll be logged in."]
            },
        ]
    },
    {
        title: "Account Termination",
        id: "delete_account",
        sections: [
            {
                title: "Step 1: Request Account Termination",
                sections: ["If you wish to delete your account, please contact our support team via the app or website.", "Alternatively, you can request account termination by sending an email to our support email address with your mobile number and a brief request to terminate your account."]
            },
            {
                title: "Step 2: Eligibility for Account Termination",
                sections: ["Please note that you cannot terminate your account within the first 3 months of creating it. This 3-month period is a minimum holding period during which we encourage you to experience our services fully."]
            },
            {
                title: "Step 3: Verify Your Identity (After 3 Months)",
                sections: ["Once you have passed the 3-month holding period, we will send an OTP to your registered mobile number for verification.", "Enter the OTP to confirm your identity before proceeding with account termination."]
            },
            {
                title: "Step 4: Account Deletion",
                sections: ["After successful identity verification, your account will be permanently deleted. This will remove all your personal data, booking history, and account details from our system.", "Important: Account termination is permanent and cannot be undone. If you decide to use our services again in the future, you will need to register a new account."]
            },
        ]
    },
    {
        title: "Troubleshooting and FAQs",
        id: "troubleshoot",
        sections: [
            {
                title: "Q1: What if I don’t receive the OTP?",
                sections: ["Please ensure that your mobile number is correct and that you have a stable network connection.", "If you still don’t receive the OTP after a few minutes, you can request a new OTP.", "Check your message inbox and spam folder, as sometimes OTPs may be mistakenly filtered out."]
            },
            {
                title: "Q2: Can I update my mobile number after registration?",
                sections: ["Yes, you can update your mobile number by contacting our support team. However, you'll need to authenticate your new number via OTP."]
            },
            {
                title: "Q3: Can I register without providing an email address?",
                sections: ["Yes, providing an email address is optional during the registration process. However, adding one helps us provide better support and updates."]
            },
            {
                title: "Q4: I’m having trouble logging in, what should I do?",
                sections: ["If you’re unable to log in, ensure that the mobile number you entered is correct.", "You can always reset your login process by entering your mobile number again and requesting a new OTP."]
            },
            {
                title: "Q5: Why can’t I delete my account before 3 months?",
                sections: ["To ensure that all users have a chance to fully explore our service and make an informed decision, we have a 3-month minimum holding period for account termination. This helps prevent misuse or accidental deletions."]
            },
            {
                title: "Q6: What if I want to delete my account sooner due to an issue or concern?",
                sections: ["If you have specific concerns or an issue with your account, please reach out to our support team. We’ll do our best to resolve the matter before you decide to delete your account."]
            },
            {
                title: "Q3: Can I deactivate my account instead of deleting it?",
                sections: ["Currently, we do not offer an account deactivation option. However, you can choose to simply stop using the service until you're eligible to terminate your account after the 3-month period."]
            },
        ]
    }
]

export const bookingSupport = [
    {
        title: "How to Book a Ride:",
        id: "howtobook",
        sections: [
            {
                title: "1.Choose Your Vehicle:",
                sections: ["Taxi: Ideal for local travel within the city.", "Two-Wheeler: Perfect for short trips, especially in traffic or when you need a more flexible option.", "4-Wheeler: Spacious and comfortable for family or group travel.", "Premium Vehicles (XUV): Great for long trips to the outskirts or when you need extra comfort for your journey."]
            },
            {
                title: "2.Enter Your Pickup and Drop-off Locations: Make sure to enter accurate addresses for a smooth pickup and drop-off experience. If you're traveling to or from an area that's more remote, please specify your exact location.",
            },
            {
                title: "3.Select Date and Time: Choose the date and time that works best for your trip. For outskirt trips, we recommend booking in advance, especially if you need a premium vehicle like an XUV.",
            },

            {
                title: "4.Payment: Choose your preferred payment method—cash, card",
            },
            {
                title: "5.Confirmation: Once your booking is confirmed, you will receive a booking ID and driver details (for cabs, bikes, or cars) so you can easily track your ride.",
            },
        ]
    },
    {
        title: "FAQs – URACAB PRIVATE LIMITED",
        id: "howtobook",
        sections: [
            {
                title: "1. How do I book a ride?",
                subsections: {
                    title: "To book a ride, simply:",
                    sections: ["Open our app.", "Enter your pickup and drop-off locations.", "Choose your preferred vehicle type: Taxi, Two-Wheeler, 4-Wheeler, or Premium Car (XUV).", "Select your date and time of travel.", "Confirm your booking and complete the payment process."]

                }
            },
            {
                title: "2. What types of vehicles can I book?",
                subsections: {
                    title: "You can book the following vehicles through our service:",
                    sections: ["Taxi: Best for city travel and short-distance trips.", "Two-Wheeler: Ideal for quick, affordable rides in city traffic.", "4-Wheeler: Perfect for group travel, family trips, or longer city rides.", "Premium Cars (XUV): Luxurious and spacious vehicles for long-distance trips, especially to the outskirts or nearby tourist destinations."]

                }
            },
            {
                title: "3. Can I book a ride for someone else?",
                sections: ["We are sorry that this features is not available yet, but soon to be available!"]
            },
            {
                title: "4. How far in advance can I book a ride?",
                sections: ["You can book a ride anytime, whether it’s immediately or up to 30 days in advance. For outskirt trips, we recommend booking at least 24 hours ahead to secure a premium vehicle, such as an XUV."]
            },
            {
                title: "5. How do I change or cancel my booking?",
                sections: ["You can change or cancel your booking via our app or website under the “My Bookings” section. If you need further assistance, feel free to contact our support team at support@uracab.com."]
            },
            {
                title: "6. What happens if my driver is late?",
                sections: ["If your driver is delayed, you’ll be notified via SMS or app notification with updated details. You can also track your driver’s location in real-time on the app. For any further issues, please contact our support team."]
            },
            {
                title: "7. Are there any additional charges for outskirt trips?",
                sections: ["Yes, there may be additional charges for long-distance or outskirt trips, especially for premium vehicles (like XUVs). These charges depend on factors like distance, tolls, and time of travel. The fare estimate is shown before you confirm your booking."]
            },
            {
                title: "8. How do I pay for my ride?",
                sections: ["Cash"]
            },
            {
                title: "9. What should I do if I leave something in the vehicle?",
                sections: ["If you leave an item in the vehicle, please contact our customer service team immediately at [Insert contact number] or use the Lost & Found option in the app. We’ll help you coordinate with the driver to retrieve your lost item."]
            },
            {
                title: "10. How can I rate my ride or provide feedback?",
                sections: ["After your trip, you can rate your ride and leave feedback directly on the app or website. Your feedback helps us improve our service and ensure a better experience for future rides."]
            },
            {
                title: "11. Can I request a specific driver or vehicle?",
                sections: ["Currently, we do not allow specific driver requests. However, you can select the vehicle type (e.g., Taxi, XUV, etc.) when booking. We'll ensure that you get a vehicle that fits your needs based on availability."]
            },
            {
                title: "12. Is it safe to book a ride with your service?",
                sections: ["Yes! Safety is our top priority. Our drivers undergo background checks, and our vehicles are regularly maintained. You can track your ride in real-time, and we also provide an SOS button for emergencies. Additionally, our app allows you to share your trip details with loved ones for added peace of mind."]
            },
            {
                title: "13. Can I book a ride to a remote or rural location?",
                sections: ["Yes, you can book rides to remote or rural locations. However, availability may vary depending on the distance and vehicle type. For premium cars like XUV, we recommend confirming availability by booking at least 24 hours in advance."]
            },
            {
                title: "14. What happens if I need to change my destination during the ride?",
                sections: ["If you need to change your destination during the ride, simply inform your driver. The fare will be adjusted based on the new route. If you’re unsure about the fare, please contact our customer support for clarification."]
            },
            {
                title: "15. Can I book a ride for a long-distance trip?",
                sections: ["Yes! Our service is available for long-distance trips, including outskirt and intercity travel. Premium cars like XUV are especially suitable for such trips. Simply select the vehicle and enter your destination at the time of booking."]
            },
            {
                title: "16. Are there any discounts or promotions available?",
                sections: ["We often offer special promotions, seasonal discounts, and referral bonuses. Keep an eye on the app, website, or our social media channels for the latest offers and discounts!"]
            },
        ]
    },
]